/**
 * @desc 列表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.LogisticsChannelResponseDto>>;
export function request(
  params: API.tms.logisticsChannel.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannel/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
